import { Check } from "lucide-react";
import { ASSETS, WERKWIJZE_PIJLERS } from "@/data";
import { Reveal, LeafDivider } from "@/components/Reveal";

export const About = () => (
  <section id="over-ons" className="py-24 lg:py-28 bg-brand-paper border-y border-brand-gold/15">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
      <Reveal className="lg:col-span-4">
        <LeafDivider label="Wie zijn wij" />
        <h2 className="font-display text-4xl sm:text-5xl text-brand-forest mt-3">Sandra & Talicia</h2>
        <div className="font-body text-brand-ink mt-5 space-y-4 leading-relaxed">
          <p>Wij zijn moeder en dochter.</p>
          <p>
            Samen creëren wij Freedom Serenity: een plek waar je rust en kalmte vindt. In deze hectische
            wereld vol angsten, verdriet, pijn en woede vonden wij onze innerlijke kracht terug.
          </p>
          <p className="font-display text-2xl text-brand-sage">Freedom Serenity is thuiskomen in jezelf.</p>
          <p className="italic text-brand-inkSoft">In die stilte herinner je je: je bent nooit echt weggeweest.</p>
        </div>
      </Reveal>

      <Reveal delay={0.12} className="lg:col-span-4 flex justify-center">
        <div className="relative">
          <div className="absolute -inset-3 rounded-[40%] border border-brand-gold/40" />
          <img src={ASSETS.talicia} alt="Talicia bij zonsondergang" className="w-64 h-80 object-cover rounded-[44%] shadow-xl" />
          <img
            src={ASSETS.sandra}
            alt="Sandra"
            className="absolute -bottom-8 -right-10 w-40 h-40 object-cover rounded-full border-4 border-brand-paper shadow-lg hidden sm:block"
          />
        </div>
      </Reveal>

      <Reveal delay={0.2} className="lg:col-span-4" id="werkwijze">
        <LeafDivider label="Onze werkwijze" />
        <h3 className="font-display text-3xl text-brand-forest mt-3">Stap voor stap bewegen</h3>
        <p className="font-body text-brand-ink mt-4 leading-relaxed">
          We doen dit niet met druk of prestatie, maar met zachtheid, rust en beleving. Alles binnen Freedom
          Serenity is gericht op het kalmeren van het zenuwstelsel en het weer voelbaar maken van de innerlijke kern.
        </p>
        <ul className="mt-5 space-y-3 font-body text-brand-ink">
          {["Van het hoofd naar het gevoel", "Van spanning naar rust", "Van overleven naar echte verbinding"].map((t) => (
            <li key={t} className="flex items-center gap-3">
              <span className="grid place-items-center w-6 h-6 rounded-full bg-brand-sage/20 text-brand-sage"><Check size={14} /></span>
              {t}
            </li>
          ))}
        </ul>
        <p className="font-body text-brand-inkSoft text-sm mt-5 leading-relaxed">
          We werken met deze pijlers, steeds gericht op voelen en loslaten:
        </p>
        <div className="flex flex-wrap gap-2 mt-3">
          {WERKWIJZE_PIJLERS.map((p) => (
            <span key={p} className="px-3 py-1.5 rounded-full bg-brand-cream2 text-brand-forest text-xs font-body tracking-wide">{p}</span>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
